<template>
  <Card class="card" dis-hover shadow>
    <!--基本信息-->
    <div class="info-wrapper">
      <div class="mar-btm30 title">
        <span class="text1">基本信息</span>
      </div>
      <div class="info">
        <Row class="row-wrap">
          <Col span="8">
            <!--企业头像-->
            <div class="box mar-btm30">
              <div class="left">企业头像</div>
              <div class="head-pic-wrapper yuan">
                <img v-if="qiye.headPic[0].path" class="yuan" :src="qiye.headPic[0].path" />
                <div v-else class="yuan logo">LOGO</div>
              </div>
            </div>
          </Col>
          <!-- <Col span="8">
            
            <div class="mar-btm30 box" v-if="isJiedao">
              <div class="left">所属社区</div>
              <div class="qiye-info" v-if="qiye.community">{{ qiye.community.name }}</div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>-->
          <Col span="8">
            <!--企业名称-->
            <div class="mar-btm30 box">
              <div class="left">企业名称</div>
              <div class="qiye-info">{{ qiye.name }}</div>
            </div>
          </Col>
        </Row>

        <Row class="row-wrap">
          <Col span="8">
            <!--企业名称-->
            <div class="mar-btm30 box">
              <div class="left">企业别名</div>
              <div class="qiye-info">{{ qiye.alias }}</div>
            </div>
          </Col>
          <Col span="8">
            <!--统一社会信用代码-->
            <div class="mar-btm30 box">
              <div class="left">统一社会信用代码</div>
              <div class="qiye-info">{{ qiye.zhuceNum }}</div>
            </div>
          </Col>
          <Col span="8">
            <!--行业类别-->
            <div class="mar-btm30 box">
              <div class="left">行业类别</div>
              <div class="qiye-info" v-if="qiye.tradeName">{{qiye.tradeName}}</div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
        </Row>
        <Row class="row-wrap">
          <Col span="8">
            <!--所在分局 -->
            <div class="mar-btm30 box">
              <div class="left">所在分局</div>
              <div class="qiye-info" v-if="qiye.deptName">{{qiye.deptName}}</div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
          <!-- <Col span="8">
            企业类型
            <div class="mar-btm30 box">
              <div class="left">企业类型</div>
              <div class="qiye-info box" v-if="qiye.qyType.length > 0">
                <div
                  v-for="(item, index) in qiye.qyType"
                  :key="index"
                  style="margin-right: 10px;"
                >{{ item.name }}</div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>-->
          <Col span="8">
            <!--服务类型-->
            <div class="mar-btm30 box">
              <div class="left">服务类型</div>
              <div class="qiye-info box" v-if="qiye.serviceType.length > 0">
                <div
                  v-for="(item, index) in qiye.serviceType"
                  :key="index"
                  style="margin-right: 10px;"
                >{{ item.name }}</div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
        </Row>
        <Row class="row-wrap">
          <Col span="8">
            <!--地址-->
            <div class="mar-btm30 box">
              <div class="left">经营地址</div>
              <div
                style="width: 200px"
                class="qiye-info slh"
                :title="qiye.zuobiao.label"
                v-if="qiye.zuobiao.label"
              >{{ qiye.zuobiao.label }}</div>
              <div class="qiye-info" v-else>无</div>
            </div>
          </Col>
          <Col span="8">
            <!--经营范围-->
            <div class="mar-btm30 box">
              <div class="left">经营范围</div>
              <div class="box" v-if="qiye.businessScope">
                <div class="qiye-info mar-rig20">{{ qiye.businessScope }}</div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
          <Col span="8">
            <!--企业法人-->
            <div class="mar-btm30 box">
              <div class="left">企业法人</div>
              <div class="box" v-if="qiye.farenName">
                <div class="qiye-info mar-rig20">{{ qiye.farenName }}</div>
                <div class="qiye-info">{{ qiye.farenTel }}</div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
        </Row>
        <Row class="row-wrap">
          <Col span="8">
            <!--企业负责人-->
            <div class="mar-btm30 box">
              <div class="left">企业负责人</div>
              <div class="box" v-if="qiye.zerenName">
                <div class="qiye-info mar-rig20">{{ qiye.zerenName }}</div>
                <div class="qiye-info">{{ qiye.zerenTel }}</div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
          <Col span="8">
            <!--职工人数-->
            <div class="mar-btm30 box">
              <div class="left">职工人数</div>
              <div class="box" v-if="qiye.employeeNum">
                <div class="qiye-info mar-rig20">{{ qiye.employeeNum }}</div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    <!--详细信息-->
    <div>
      <div class="mar-btm30 title">
        <span class="text1">企业详细信息</span>
      </div>

      <div class="info">
        <Row class="row-wrap">
          <Col span="8">
            <!--经营面积-->
            <div class="mar-btm30 box">
              <div class="left">经营面积</div>
              <div class="qiye-info" v-if="qiye.area">{{ qiye.area }}&nbsp;&nbsp;平方米</div>
              <div class="qiye-info" v-else>无</div>
            </div>
          </Col>
          <Col span="8">
            <!--经营时间-->
            <div class="mar-btm30 box">
              <div class="left" style="align-self: self-start">经营时间</div>
              <div class v-if="qiye.timeList.length">
                <div v-for="(item, index) in qiye.timeList" :key="index" class="box item-time">
                  <div class="qiye-info">{{ item.beginTime }}</div>
                  <div class="qiye-info">&nbsp;&nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;&nbsp;&nbsp;</div>
                  <div class="qiye-info">{{ item.endTime }}</div>
                </div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
          <Col span="8">
            <!--是否可派送-->
            <div class="mar-btm30 box">
              <div class="left">是否有送货服务</div>
              <div class="qiye-info">{{ qiye.paisong }}</div>
            </div>
          </Col>
        </Row>

        <Row class="row-wrap">
           <Col span="8">
            <!--企业类型-->
            <div class="mar-btm30 box">
              <div class="left">企业类型</div>
              <div class="qiye-info" v-if="qiye.companyType">{{ qiye.companyType }}</div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
          <Col span="8">
            <!--企业性质-->
            <div class="mar-btm30 box">
              <div class="left">企业性质</div>
              <div class="qiye-info" v-if="qiye.xingzhi.name">{{ qiye.xingzhi.name }}</div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
          <Col span="8">
            <!--企业属性-->
            <div class="mar-btm30 box">
              <div class="left">企业属性</div>
              <div class="qiye-info box" v-if="qiye.qyNature.length > 0">
                <div
                  v-for="(item, index) in qiye.qyNature"
                  :key="index"
                  style="margin-right: 10px;"
                >{{ item.name }}</div>
              </div>
              <div class="qiye-info" v-else>社区服务综合体</div>
            </div>
          </Col>
        </Row>

        <Row class="row-wrap">
          <Col span="8">
            <!--派送时间-->
            <div class="mar-btm30 box" v-if="qiye.paisong == '是'">
              <div class="left" style="align-self: self-start">派送时间</div>
              <div class v-if="qiye.paisongTime.length">
                <div v-for="(item, index) in qiye.paisongTime" :key="index" class="box item-time">
                  <div class="qiye-info">{{ item.beginTime }}</div>
                  <div class="qiye-info">&nbsp;&nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;&nbsp;&nbsp;</div>
                  <div class="qiye-info">{{ item.endTime }}</div>
                </div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
        </Row>
        <Row class="row-wrap">
          <Col span="8">
            <!--企业图片-->
            <div class="mar-btm30 box">
              <div class="left box">企业图片</div>
              <div
                class="qiye-info box_f1 box"
                v-if="qiye.imgArr.length > 0"
                style="flex-wrap:wrap"
              >
                <div v-for="(item, index) in qiye.imgArr" :key="index">
           
                  <el-image
                  :preview-src-list="[item.path]"
                  
                    :src="item.path"
                    style="width: 80px;height: 80px;margin-right: 20px;margin-bottom:20px"
                  />
                </div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
          <Col span="8">
            <!--营业执照-->
            <div class="mar-btm30 box">
              <div class="left box">营业执照</div>
              <div
                class="qiye-info box_f1 box"
                v-if="qiye.licensePicArr && qiye.licensePicArr.length >0"
                style="flex-wrap:wrap"
              >
                <!-- <div > -->
                  <el-image
                  :preview-src-list="[item]"
                  v-for="(item, index) in qiye.licensePicArr" :key="index"
                    :src="item"
                    style="width: 80px;height: 80px;margin-right: 20px;margin-bottom:20px"
                  />
                <!-- </div> -->
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
          <Col span="8">
            <!--各类许可证明-->
            <div class="mar-btm30 box">
              <div class="left box">各类许可证明(类似食品许可证等)</div>
              <div
                class="qiye-info box_f1 box"
                v-if="qiye.allKindPicArr && qiye.allKindPicArr.length >0"
                style="flex-wrap:wrap"
              >
                <div v-for="(item, index) in qiye.allKindPicArr" :key="index">
               
                  <el-image
                  :preview-src-list="[item]"
                  
                    :src="item"
                    style="width: 80px;height: 80px;margin-right: 20px;margin-bottom:20px"
                  />
                </div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
        </Row>
        <!-- <Row class="row-wrap">
           <Col span="8">
            承诺书
            <div class="mar-btm30 box">
              <div class="left box">承诺书</div>
              <div
                class="qiye-info box_f1 box"
                v-if="qiye.promisePicArr && qiye.promisePicArr.length >0"
                style="flex-wrap:wrap"
              >
                <div v-for="(item, index) in qiye.promisePicArr" :key="index">
                  <img
                    :src="item"
                    style="width: 80px;height: 80px;margin-right: 20px;margin-bottom:20px"
                  />
                </div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
          <Col span="8">
            健康证明
            <div class="mar-btm30 box">
              <div class="left box">健康证明</div>
              <div
                class="qiye-info box_f1 box"
                v-if="qiye.healthyPicArr && qiye.healthyPicArr.length >0"
                style="flex-wrap:wrap"
              >
                <div v-for="(item, index) in qiye.healthyPicArr" :key="index">
                  <img
                    :src="item"
                    style="width: 80px;height: 80px;margin-right: 20px;margin-bottom:20px"
                  />
                </div>
              </div>
              <div v-else class="qiye-info">无</div>
            </div>
          </Col>
        </Row>-->
        <!-- <Row class="row-wrap">
          <Col span="16">
            企业简介
            <div class="pad-btm30 box">
              <div class="left">企业简介</div>
              <div class="qiye-info jianjie">{{ jianjie }}</div>
            </div>
          </Col>
        </Row>-->
      </div>
    </div>
  </Card>
</template>

<script>
export default {
  props: {
    qiye: {
      type: Object,
      default: {}
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    isJiedao() {
      return this.$store.state.isJiedao;
    },
    changeColor() {
      return function(index, type) {
        if (type == "border") {
          return this.selectIndex == index ? "#ff7b44" : "#dedede";
        }
        if (type == "text") {
          return this.selectIndex == index ? "#ff7b44" : "#999";
        }
      };
    },
    jianjie() {
      let reg = /<\/?.+?\/?>/g;
      return this.qiye.jianjie ? this.qiye.jianjie.replace(reg, "") : "";
    }
  },
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped >
.row-wrap {
  margin-bottom: 50px;
}
.upload-img >>> .imgbox {
  margin-bottom: 0px !important;
}
.left {
  text-align: right;
  margin-right: 20px;
}
.card {
  width: 97%;
}
.title {
  padding: 20px 0 0 20px;
  text-align: left;
}
.info-wrapper {
  padding-bottom: 30px;
  border-bottom: 1px solid #dddddd;
}
.mar-btm10 {
  margin-bottom: 10px;
}
.mar-btm20 {
  margin-bottom: 20px;
}
.mar-btm30 {
  margin-bottom: 40px;
}
.mar-btm30:last-child {
  margin-bottom: 0;
}
.pad-btm30 {
  padding-bottom: 30px;
}
.mar-rig20 {
  margin-right: 20px;
}
.text1 {
  font-size: 20px;
  color: #333;
  padding-right: 10px;
  font-weight: 600;
}
.text2 {
  font-size: 14px;
  color: #999;
  margin-left: 20px;
}
.text3 {
  font-size: 11px;
  color: #666;
  padding-left: 10px;
}
.text4 {
  font-size: 14px;
  color: #999;
  margin: 0 20px;
}
.info {
  font-size: 16px;
  color: #333;
  line-height: 1;
  padding-left: 20px;
}
.qiye-info {
  color: #999;
  font-size: 15px;
}
.yuan {
  width: 100px;
  height: 100px;
  border-radius: 100%;
}
.head-pic {
  display: flex;
  align-items: center;
}
.head-pic-wrapper {
  position: relative;
  margin-left: 20px;
}

.logo {
  background: #efefef;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.yingyezhizhao {
  position: absolute;
  margin-bottom: 30px;
  left: 50%;
  top: 20px;
}
.zhizhao-wrapper {
  padding-left: 60px;
  align-items: center;
}
.jianjie {
  width: 52.36%;
  height: 250px;
  padding: 20px;
  border: 1px solid #dedede;
}
.service-item-wrapper {
  position: relative;
  border: 1px solid #dedede;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  color: #999;
  font-size: 14px;
  border-radius: 5px;
  margin-right: 20px;
  align-items: center;
  color: #999;
}
.icon-wrapper {
  height: 20px;
  width: 20px;
  border-radius: 100%;
  margin-right: 10px;
}
.icon {
  color: #fff;
  font-size: 19px;
  margin-top: -4px;
  margin-left: 1px;
}
.item-time {
  margin-bottom: 10px;
}
.item-time:last-child {
  margin-bottom: 0;
}

</style>
